import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ru from 'vuetify/src/locale/ru';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#034EA1",
            },
        },
    },
    lang: {
        locales: { ru },
        current: 'ru',
    },
});
